// eslint-disable-next-line no-unused-vars
/* globals SHADOW_BYPASS, STANDALONE */

/**
 * Get the builder's shadow root. For tests and stories where shadow is
 * bypassed, the window's document is returned instead
 */
export const getBuilderRoot = () => {
  const builderTagName = `appcues-builder${
    import.meta.env.STANDALONE ? '-standalone' : ''
  }`;
  const $builder = document.querySelector(builderTagName);
  return import.meta.env.SHADOW_BYPASS ? document : $builder.shadowRoot;
};

export const getBuilderElement = () => {
  const builderTagName = `appcues-builder${
    import.meta.env.STANDALONE ? '-standalone' : ''
  }`;
  const $builder = document.querySelector(builderTagName);
  return import.meta.env.SHADOW_BYPASS ? document : $builder;
};

/**
 * Get the portal's root element within the builder
 */
export const getPortalRoot = ($builder = getBuilderRoot()) => {
  return $builder.querySelector('#portal-root');
};

/**
 * Get the editor's document object nested within shadow roots and iframes
 */
export const getEditorDocument = ($builder = getBuilderRoot()) => {
  if (!$builder) {
    return null;
  }

  const $editor = $builder.querySelector('#editor');
  if (!($editor && $editor.shadowRoot)) {
    return null;
  }

  const $frame = $editor.shadowRoot.querySelector('iframe');
  if (!$frame) {
    return null;
  }

  return $frame.contentWindow.document;
};
